// extracted by mini-css-extract-plugin
module.exports = {"panelContainer":"Panel_panelContainer__wIM7j","panelHeader":"Panel_panelHeader__1Rum0"};